import { v4 } from 'uuid';

/**
 * UUID4 를 가져옵니다.
 */
export const uuidv4 = () => v4();
